export default __webpack_public_path__ + "static/media/g8.ebf62c82.jpg";